import { FaGooglePlay } from "react-icons/fa";
import mob_img from "../../../assets/images/mob-banner.png";   // phone mockup
import qr_img from "../../../assets/images/qr-code.png";      // QR code
import "./PromoBanner.css";

const PromoBanner = () => {
  return (
    <section className="promo-banner">
      <div className="container d-flex flex-column flex-lg-row align-items-center justify-content-evenly">
        
        {/* Left Side */}
        <div className="col-lg-6 mb-5 mb-lg-0 text-center text-lg-start">
        <h1 className="title">
          Find Your <span className="highlight">Perfect Property</span>
        </h1>
        <p className="subtitle mt-3">
          Ready to upgrade your living? Browse stunning homes with  
          modern designs, smart layouts, and everything you need to  
          start your next chapter.
        </p>
 
          {/* Playstore + QR */}
          <div className="playstore-col mt-3">
            <a
              href="https://play.google.com/store/apps/details?id=com.AllHomeDesire.AllHomeDesire"
              target="_blank"
              rel="noopener noreferrer"
              className="playstore-btn"
            >
              <FaGooglePlay size={28} className="icon" />
              <div className="texts">
                <span className="text-1">GET IT ON</span>
                <span className="text-2">Google Play</span>
              </div>
            </a>
            <div className="qr-box">
              <img src={qr_img} alt="QR Code" />
              <span>Scan to Download</span>
            </div>

          </div>

        </div>

        {/* Right Side (Phone Image) */}
        <div>
          <img
            src={mob_img}
            alt="App Preview"
            className="phone-img"
          />
        </div>
      </div>
    </section>
  );
};

export default PromoBanner;
